module.exports = __webpack_public_path__ + "img/completed.0c390e57.svg";